var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insert_tag",
    "data-name": "Insert tag",
    transform: "translate(-491 -483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 18,
    height: 18,
    transform: "translate(491 483)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bookmark",
    d: "M17.624,19.23l-6.312-4.508L5,19.23V4.8A1.8,1.8,0,0,1,6.8,3H15.82a1.8,1.8,0,0,1,1.8,1.8Z",
    transform: "translate(488.688 480.885)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertTagIcon);
export default __webpack_public_path__ + "static/media/insert-tag-icon.1cd3db1eb2e4d8be316779a239706e09.svg";
export { ForwardRef as ReactComponent };